export const sumQty = (arr) => {
  const qty = arr.reduce((acc, current) => acc + current, 0);

  return qty;
};
